import { cva } from 'class-variance-authority';

import s from './AutoFillButton.module.css';

export const autoFillButtonVariants = cva(s.button, {
  defaultVariants: {
    disabled: false,
    loading: false,
  },
  variants: {
    disabled: {
      true: s.buttonDisabled,
    },
    loading: {
      true: s.buttonLoading,
    },
  },
});
